import React from 'react';

import { useMindmap } from '../../pages/mindmap/use-mindmap';
import { MapContextMenu } from '../ui/map-context-menu';
import { FileContextMenu } from './node-attachement/file-context-menu';
import { LinkContextMenu } from './node-attachement/link-context-menu';
import { NodeContextMenu } from './node-context-menu';
import { FormatTextContextMenu } from './node-types/format-text-context-menu/format-text-context-menu';
import { LinkTextContextMenu } from './node-types/link-text-context-menu';

export const ContextMenus = () => {
  const {
    contextMenu: { activeMenu },
    selection: { selectedNodeIds },
  } = useMindmap();

  return (
    <>
      {!!activeMenu && (
        <MapContextMenu isOpen={!!activeMenu}>
          <div
            onClick={(e) => {
              // prevent closing of menus
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {activeMenu.type == 'edit-node' && <NodeContextMenu />}
            {activeMenu.type == 'format-text' && <FormatTextContextMenu />}
            {activeMenu.type == 'link-text' && <LinkTextContextMenu />}
            {activeMenu.type == 'add-file-attachement' && (
              <FileContextMenu
                nodeId={selectedNodeIds[0]}
                creatingMode={true}
                onCreateClick={activeMenu.onCreateClick}
              />
            )}
            {activeMenu.type == 'add-link-attachement' && (
              <LinkContextMenu
                nodeId={selectedNodeIds[0]}
                creatingMode={true}
                onCreateClick={activeMenu.onCreateClick}
              />
            )}
            {activeMenu.type == 'edit-file-attachement' && (
              <FileContextMenu nodeId={activeMenu.nodeId} attachement={activeMenu.attachement} />
            )}
            {activeMenu.type == 'edit-link-attachement' && (
              <LinkContextMenu nodeId={activeMenu.nodeId} attachement={activeMenu.attachement} />
            )}
          </div>
        </MapContextMenu>
      )}
    </>
  );
};
